import { getLocale } from '../../utils/pathHelper';

type TranslationKeys =
'adultPrice'|
'childPrice'|
'groupPrice'|
'studentPrice'|
'seniorPrice'|
'thisIsConsecutiveDayPass'|
'pleaseSelectStartDate'|
'thisDateIsNotAvailable'|
'lessonOnTheDateYouHaveChosenIsAvailablePleaseSelectTimeSchedule'|
'sorryWeCouldNotFindAnyLessonAvailableOnTheDate'|
'back';

type TranslationLocales = 'en'|'ja'|'zh-CN'|'zh-HK'|'zh-TW';

export type ITranslation = {
  [key in TranslationKeys]: ({}?: { [arg: string]: string|number }) => string;
}

const locales: {
  [locale in TranslationLocales]: ITranslation
} = {
  'en': {
    adultPrice: () => ('Adult'),
    childPrice: () => ('Child'),
    groupPrice: () => ('Group'),
    studentPrice: () => ('Student'),
    seniorPrice: () => ('Senior'),
    thisIsConsecutiveDayPass: ({ dateDuration }) => (`This is a ${dateDuration}-day ticket.`),
    pleaseSelectStartDate: () => ('Please select a start date.'),
    thisDateIsNotAvailable: () => ('This date is not available.'),
    lessonOnTheDateYouHaveChosenIsAvailablePleaseSelectTimeSchedule: () => ('A lesson is available on the selected day. Please choose a time.'),
    sorryWeCouldNotFindAnyLessonAvailableOnTheDate: () => ('A lesson is not available on the selected day.'),
    back: () => ('Back'),
  },
  'ja': {
    adultPrice: () => ('大人'),
    childPrice: () => ('子供'),
    groupPrice: () => ('グループ'),
    studentPrice: () => ('学生'),
    seniorPrice: () => ('シニア'),
    thisIsConsecutiveDayPass: ({ dateDuration }) => (`この商品は${dateDuration}日間の連日券です。`),
    pleaseSelectStartDate: () => ('利用開始日を選択してください。'),
    thisDateIsNotAvailable: () => ('この日付は選択できません'),
    lessonOnTheDateYouHaveChosenIsAvailablePleaseSelectTimeSchedule: () => ('ご希望の日程でレッスンに空きがあります。時間帯を選択してください。'),
    sorryWeCouldNotFindAnyLessonAvailableOnTheDate: () => ('申し訳ありません。ご希望の日程ではレッスンに空きが見つかりませんでした。'),
    back: () => ('戻る'),
  },
  'zh-CN': {
    adultPrice: () => ('成人'),
    childPrice: () => ('儿童'),
    groupPrice: () => ('团体'),
    studentPrice: () => ('学生'),
    seniorPrice: () => ('老年人'),
    thisIsConsecutiveDayPass: ({ dateDuration }) => (`此商品为${dateDuration}日的多日券。`),
    pleaseSelectStartDate: () => ('请选择开始使用的日期。'),
    thisDateIsNotAvailable: () => ('无法选择此日期。'),
    lessonOnTheDateYouHaveChosenIsAvailablePleaseSelectTimeSchedule: () => ('所选择的日期可申请课程，请选择时段。'),
    sorryWeCouldNotFindAnyLessonAvailableOnTheDate: () => ('非常抱歉，所选择的日期课程已售罄。'),
    back: () => ('返回'),
  },
  'zh-HK': {
    adultPrice: () => ('成人'),
    childPrice: () => ('小童'),
    groupPrice: () => ('團體'),
    studentPrice: () => ('學生'),
    seniorPrice: () => ('長者'),
    thisIsConsecutiveDayPass: ({ dateDuration }) => (`此商品為${dateDuration}日的多日券。`),
    pleaseSelectStartDate: () => ('請選擇開始使用的日期。'),
    thisDateIsNotAvailable: () => ('無法選擇此日期。'),
    lessonOnTheDateYouHaveChosenIsAvailablePleaseSelectTimeSchedule: () => ('所選的日期有可供預約的課堂。請選擇時間。'),
    sorryWeCouldNotFindAnyLessonAvailableOnTheDate: () => ('抱歉！所選的日期沒有可供預約的課堂。'),
    back: () => ('返回'),
  },
  'zh-TW': {
    adultPrice: () => ('成人'),
    childPrice: () => ('兒童'),
    groupPrice: () => ('團體'),
    studentPrice: () => ('學生'),
    seniorPrice: () => ('年長者'),
    thisIsConsecutiveDayPass: ({ dateDuration }) => (`此商品為${dateDuration}日的多日券。`),
    pleaseSelectStartDate: () => ('請選擇開始使用的日期。'),
    thisDateIsNotAvailable: () => ('無法選擇此日期。'),
    lessonOnTheDateYouHaveChosenIsAvailablePleaseSelectTimeSchedule: () => ('所選擇的日期可申請課程，請選擇時段。'),
    sorryWeCouldNotFindAnyLessonAvailableOnTheDate: () => ('非常抱歉，所選擇的日期課程已售罄。'),
    back: () => ('返回'),
  },
};

const t: ITranslation = locales[getLocale() || 'en'];

export default t;
